module.exports = __webpack_public_path__ + "img/header_bg2.7286b8f3.jpg";